var object = {
  methods: {},
  computed: {},
  watch: {},
  name: 'public_bottom',
  data() {
    return {
      nors_: {},
      rs_: {},
      show_: {},
      parem_: {}
    };
  },
  // 注册子组件
  components: {},
  // 动态更新页面，完成时触发
  updated() {}
};
export default object;